import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StoreModule } from '../store/store.module';

// Import dependent modules
@NgModule({
    imports: [CommonModule, StoreModule],
    providers: [
        // Business logic services will be added here during migration
    ],
    exports: [
        // Services to be exported will be added here
    ],
})
export class DomainModule {}
